export default {
    meta: {
        title: '版本升级',
        isShowHeader: false
    },
};
